module.exports = __webpack_public_path__ + "site/img/team_member_蔡閔秋.3d0961b4.jpg";